import React from "react";
import { ChatCircleDots } from "@phosphor-icons/react";
import { COMPANY } from "@/lib/site-data";

/**
 * "Text us a photo" call-to-action strip. Meant to sit directly below the
 * Sizing Guide, Pricing table, and Book Now sections.
 */
export default function TextPhotoCta({ testid = "text-photo-cta", className = "" }) {
  const smsHref = `sms:${COMPANY.phoneRaw}?body=${encodeURIComponent(
    "Hi Troya Mini Bins — attached is a photo of my job site. What bin & price do you recommend?"
  )}`;
  return (
    <div
      data-testid={testid}
      className={`border-2 border-slate-900 bg-slate-900 text-white px-5 py-4 sm:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 ${className}`}
    >
      <div className="h-11 w-11 bg-sky-500 text-slate-900 flex items-center justify-center shrink-0">
        <ChatCircleDots size={22} weight="fill" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] font-extrabold tracking-[0.22em] uppercase text-sky-400">
          Fast lane
        </div>
        <div className="font-display font-bold text-base sm:text-lg leading-tight mt-0.5">
          Not sure what you need? Text us a photo of the job site.
        </div>
        <div className="text-sm text-slate-300 mt-1">
          We&apos;ll tell you the exact bin and price in under 5 minutes.
        </div>
      </div>
      <a
        href={smsHref}
        data-testid={`${testid}-sms`}
        className="inline-flex items-center gap-2 px-4 py-2.5 bg-sky-500 hover:bg-white hover:text-slate-900 text-slate-900 border-2 border-sky-500 hover:border-white font-bold text-xs uppercase tracking-[0.18em] transition-colors shrink-0"
      >
        Text {COMPANY.phone}
      </a>
    </div>
  );
}
